import KioskActivityContainer from './kiosk-activity-container';

export default KioskActivityContainer;
